import HeroGraphics1 from "../HeroGraphics1/HeroGraphics1";
import { motion, useAnimation } from "framer-motion";
import {
  HeroGraphics2,
  HeroGraphics3,
  HeroGraphics3Dark,
  HeroRightContainer,
  InnerLeftContainer,
} from "./HeroRight.styles";
import { useState, useEffect } from "react";

const slideAnimation = {
  hidden: { x: "80%", opacity: 0, transition: { duration: 0.5 } },
  visible: { x: 0, opacity: 1, transition: { duration: 0.5 } },
};

const HeroRight = () => {
  const [isLight, setIsLight] = useState(true);
  const controls = useAnimation();

  useEffect(() => {
    const intervalId = setInterval(async () => {
      await controls.start("hidden");
      setIsLight((prev) => !prev);
      await controls.start("visible");
    }, 3000);

    return () => clearInterval(intervalId);
  }, [controls]);

  return (
    <HeroRightContainer>
      <InnerLeftContainer>
        <HeroGraphics1 />
        <HeroGraphics2 />
      </InnerLeftContainer>

      <motion.div
        style={{ position: "relative" }}
        initial="hidden"
        animate={controls}
        variants={slideAnimation}
      >
        {isLight ? <HeroGraphics3Dark /> : <HeroGraphics3 />}
      </motion.div>
    </HeroRightContainer>
  );
};

export default HeroRight;
